import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Col, Form, Row, Table } from "antd";
import PropTypes from "prop-types";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import { numberWithCommas } from "../../../../../../utils/number";

class InVacationDayInformation extends Component {
  state = {
    columns: [
      {
        title: "ครั้งที่",
        dataIndex: "studyExtendSort",
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "เลขที่คำสั่งอนุมัติ",
        dataIndex: "studyExtendDocumentNo",
        width: 300,
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "รายละเอียด",
        dataIndex: "studyExtendDetail",
        width: 300,
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "วันที่คำสั่งอนุมัติ",
        dataIndex: "studyExtendDocumentDate",
        width: 200,
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "วันที่เริ่มต้น",
        dataIndex: "studyExtendDateFrom",
        width: 200,
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "วันที่สิ้นสุด",
        dataIndex: "studyExtendDateTo",
        width: 200,
        align: "center",
        render: (item, record, index) => (item ? changeFormatdate(item) : "-"),
      },
      {
        title: "จำนวนวัน",
        dataIndex: "studyExtendDuration",
        width: 100,
        align: "center",
        render: (item, record, index) => (item ? item : "-"),
      },
      {
        title: "ประเภทการขยายระยะเวลาฯ",
        dataIndex: "studyExtendTypeName",
        width: 200,
        align: "center",
        render: (item, record, index) => item || "-",
      },
      {
        title: "หมายเหตุ/เหตุผลการขอขยายฯ",
        dataIndex: "studyExtendRemark",
        width: 300,
        align: "center",
        render: (item, record, index) => item || "-",
      },
    ],
    summarystudyExtendDuration:0
  };

  async componentDidMount() {
    const {
      rawData,
    } = this.props;
    const studyExtends = rawData?.studyExtends || [];
    
    let summarystudyExtendDuration = 0;

    if(studyExtends?.length > 0)
    {
      studyExtends.forEach(({ studyExtendDuration }) => {
      if (studyExtendDuration) {
        // summaryStudyFeeDetailPrice += parseFloat(studyFeeDetailPrice.replace(/,/g, ""));
        if (isFinite(String(studyExtendDuration))) {
          summarystudyExtendDuration += parseInt(studyExtendDuration);
        } else {
          summarystudyExtendDuration += parseInt(studyExtendDuration.replace(/,/g, ""));
        }
      }
    });

    this.setState({ summarystudyExtendDuration });
    }
    

  }

  render() {
    const { columns, summarystudyExtendDuration } = this.state;
    const { rawData } = this.props;
    const studyExtends = rawData?.studyExtends || [];

    return (
      <Row gutter={16} type="flex" justify="left" align="top">
        <Col xs={24} md={24} className="pt-0">
          <strong className="color-red">ข้อมูลวันลา</strong>
        </Col>
        <Col xs={24} md={24} align={"right"} className="pt-4">
          <Table
            columns={columns}
            dataSource={studyExtends}
            pagination={false}
            className="mb-3"
            bordered
            locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
            scroll={{ x: "max-content" }}
            rowKey="id"
          />
        </Col>
        <Col xs={24} md={24} className="pt-0" align="end">
        รวมจำนวน {summarystudyExtendDuration} วัน
        </Col> 
      </Row>
      
    );
  }
}

InVacationDayInformation.defaultProps = {
  autoFocus: false,
};

InVacationDayInformation.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedInVacationDayInformation = Form.create()(InVacationDayInformation);

export default withApollo(WrappedInVacationDayInformation);
